// Dependencies
import styled from 'styled-components';

// Images
import previous from '../../img/icons/carousels/previous.svg';
import next from '../../img/icons/carousels/next.svg';

const SliderStyles = styled.div`
  .slider {
    --slide-width: ${(props) => 100 / (props.slides || 1)}%;
    --slide-gap: ${(props) => props.gap}rem;
  }

  .slider-viewport {
    position: relative;
    overflow: hidden;
  }

  .slider-container {
    backface-visibility: hidden;
    display: flex;
    touch-action: pan-y;
    margin-left: calc(var(--slide-gap) * -1);
  }

  .slider-container > * {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 var(--slide-width);
    padding-left: var(--slide-gap);
  }

  .slider-prev,
  .slider-next {
    position: absolute;
    top: 50%;
    width: 2.5rem;
    height: 2.5rem;
    margin-top: -5rem;
    z-index: 100;
    cursor: pointer;
    background-color: var(--color-sand);
    background-size: 1.5rem;
    background-position: center;
    border-radius: 100%;
    box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.4);
  }

  .slider-prev {
    left: 1rem;
    background-image: url(${previous});
  }

  .slider-next {
    right: 1rem;
    background-image: url(${next});
  }

  .dots {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 1.5rem 1rem 0 1rem;

    .dot {
      padding: 0 0.05rem;
      font-size: 1.5rem;
      color: var(--color-bark);
      opacity: 0.4;
      transition:
        color 0.4s,
        opacity 0.4s;

      &.active {
        color: var(--color-charcoal);
        opacity: 1;
      }
    }
  }

  @media (min-width: 375px) {
    .slider {
      --slide-width: ${(props) =>
        100 / (props.breakpoints[375].slides || props.slides)}%;
      --slide-gap: ${(props) => props.breakpoints[375].gap || props.gap}rem;
    }
  }

  @media (min-width: 768px) {
    .slider {
      --slide-width: ${(props) =>
        100 /
        (props.breakpoints[768].slides || props.breakpoints[375].slides)}%;
      --slide-gap: ${(props) =>
        props.breakpoints[768].gap || props.breakpoints[375].gap}rem;
    }

    .slider-prev {
      left: 2rem;
    }

    .slider-next {
      right: 2rem;
    }
  }

  @media (min-width: 992px) {
    .slider {
      --slide-width: ${(props) =>
        100 /
        (props.breakpoints[992].slides || props.breakpoints[768].slides)}%;
      --slide-gap: ${(props) =>
        props.breakpoints[992].gap || props.breakpoints[768].gap}rem;
    }
  }

  @media (min-width: 1200px) {
    .slider {
      --slide-width: ${(props) =>
        100 /
        (props.breakpoints[1200].slides || props.breakpoints[992].slides)}%;
      --slide-gap: ${(props) =>
        props.breakpoints[1200].gap || props.breakpoints[992].gap}rem;
    }
  }

  @media (min-width: 1920px) {
    .slider {
      --slide-width: ${(props) =>
        100 /
        (props.breakpoints[1920].slides || props.breakpoints[1200].slides)}%;
      --slide-gap: ${(props) =>
        props.breakpoints[1920].gap || props.breakpoints[1200].gap}rem;
    }
  }
`;

export default SliderStyles;
